<template>
  <v-row class="mt-16" justify="center">
    <v-col md="4">
      <v-card elevation="2">
        <v-card-title>Enter Details</v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-text-field
              v-model="firstname"
              :rules="nameRules"
              label="First Name"
              outlined
              required
            >
            </v-text-field>

            <v-text-field
              v-model="lastname"
              :rules="nameRules"
              label="Last Name"
              outlined
              required
            >
            </v-text-field>

            <v-select
              return-object
              v-model="country"
              :items="countries"
              :rules="countryRules"
              label="Country"
              outlined
              required
            >
            </v-select>
            <v-text-field
              v-model="walletAddress"
              :rules="walletRules"
              label="Valid Metamask Wallet ID"
              outlined
              required
            >
            </v-text-field>
            <v-divider></v-divider>
            <v-card-text
              >Please provide the necessary documentation to verify your
              account</v-card-text
            >

            <v-file-input
              label="Identity Document"
              outlined
              :rules="fileRules"
              required
              accept="image/png, image/jpeg, image/bmp"
              dense
              v-model="idFile"
            ></v-file-input>
            <v-file-input
              label="Proof of residence"
              :rules="fileRules"
              outlined
              dense
              required
              v-model="proofFile"
            ></v-file-input>

            <v-btn
              elevation="2"
              color="primary"
              @click="registerDetails"
              :loading="isLoading"
            >
              Save details
            </v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { storage, usersCollection } from "@/firebase";
import router from "@/router/index";

export default {
  data() {
    return {
      fileRules: [
        value => !value || value.size > 0 || 'Please provide a valid documentation file',
        value => !value || value.size < 8000000 || 'File size should be less than 8 MB!',
      ],
      isLoaded: false,
      isLoading: false,
      show: false,
      valid: false,
      walletAddress: "",
      firstname: "",
      lastname: "",
      country: "",
      errors: "",
      nameRules: [(v) => !!v || "Name is required"],
      countryRules: [(v) => !!v || "Country is required"],
      walletRules: [
        (v) => !!v || "Metamask wallet address is required",
        (v) =>
          v.length >= 16 || "Wallet address must be a minimum of 16 characters",
      ],
      emailRules: [
        (v) => !!v || "Email is required",
        (v) => /.+@.+/.test(v) || "Email must be valid",
      ],
      passwordRules: [
        (v) => !!v || "Password is required",
        (v) => v.length >= 8 || "Password must be 8 characters or more",
      ],
      countries: [
        "Afghanistan",
        "Albania",
        "Algeria",
        "American Samoa",
        "Andorra",
        "Angola",
        "Anguilla",
        "Antarctica",
        "Antigua and Barbuda",
        "Argentina",
        "Armenia",
        "Aruba",
        "Australia",
        "Austria",
        "Azerbaijan",
        "Bahamas (the)",
        "Bahrain",
        "Bangladesh",
        "Barbados",
        "Belarus",
        "Belgium",
        "Belize",
        "Benin",
        "Bermuda",
        "Bhutan",
        "Bolivia (Plurinational State of)",
        "Bonaire, Sint Eustatius and Saba",
        "Bosnia and Herzegovina",
        "Botswana",
        "Bouvet Island",
        "Brazil",
        "British Indian Ocean Territory (the)",
        "Brunei Darussalam",
        "Bulgaria",
        "Burkina Faso",
        "Burundi",
        "Cabo Verde",
        "Cambodia",
        "Cameroon",
        "Canada",
        "Cayman Islands (the)",
        "Central African Republic (the)",
        "Chad",
        "Chile",
        "China",
        "Christmas Island",
        "Cocos (Keeling) Islands (the)",
        "Colombia",
        "Comoros (the)",
        "Congo (the Democratic Republic of the)",
        "Congo (the)",
        "Cook Islands (the)",
        "Costa Rica",
        "Croatia",
        "Cuba",
        "Curaçao",
        "Cyprus",
        "Czechia",
        "Côte d'Ivoire",
        "Denmark",
        "Djibouti",
        "Dominica",
        "Dominican Republic (the)",
        "Ecuador",
        "Egypt",
        "El Salvador",
        "Equatorial Guinea",
        "Eritrea",
        "Estonia",
        "Eswatini",
        "Ethiopia",
        "Falkland Islands (the) [Malvinas]",
        "Faroe Islands (the)",
        "Fiji",
        "Finland",
        "France",
        "French Guiana",
        "French Polynesia",
        "French Southern Territories (the)",
        "Gabon",
        "Gambia (the)",
        "Georgia",
        "Germany",
        "Ghana",
        "Gibraltar",
        "Greece",
        "Greenland",
        "Grenada",
        "Guadeloupe",
        "Guam",
        "Guatemala",
        "Guernsey",
        "Guinea",
        "Guinea-Bissau",
        "Guyana",
        "Haiti",
        "Heard Island and McDonald Islands",
        "Holy See (the)",
        "Honduras",
        "Hong Kong",
        "Hungary",
        "Iceland",
        "India",
        "Indonesia",
        "Iran (Islamic Republic of)",
        "Iraq",
        "Ireland",
        "Isle of Man",
        "Israel",
        "Italy",
        "Jamaica",
        "Japan",
        "Jersey",
        "Jordan",
        "Kazakhstan",
        "Kenya",
        "Kiribati",
        "Korea (the Democratic People's Republic of)",
        "Korea (the Republic of)",
        "Kuwait",
        "Kyrgyzstan",
        "Lao People's Democratic Republic (the)",
        "Latvia",
        "Lebanon",
        "Lesotho",
        "Liberia",
        "Libya",
        "Liechtenstein",
        "Lithuania",
        "Luxembourg",
        "Macao",
        "Madagascar",
        "Malawi",
        "Malaysia",
        "Maldives",
        "Mali",
        "Malta",
        "Marshall Islands (the)",
        "Martinique",
        "Mauritania",
        "Mauritius",
        "Mayotte",
        "Mexico",
        "Micronesia (Federated States of)",
        "Moldova (the Republic of)",
        "Monaco",
        "Mongolia",
        "Montenegro",
        "Montserrat",
        "Morocco",
        "Mozambique",
        "Myanmar",
        "Namibia",
        "Nauru",
        "Nepal",
        "Netherlands (the)",
        "New Caledonia",
        "New Zealand",
        "Nicaragua",
        "Niger (the)",
        "Nigeria",
        "Niue",
        "Norfolk Island",
        "Northern Mariana Islands (the)",
        "Norway",
        "Oman",
        "Pakistan",
        "Palau",
        "Palestine, State of",
        "Panama",
        "Papua New Guinea",
        "Paraguay",
        "Peru",
        "Philippines (the)",
        "Pitcairn",
        "Poland",
        "Portugal",
        "Puerto Rico",
        "Qatar",
        "Republic of North Macedonia",
        "Romania",
        "Russian Federation (the)",
        "Rwanda",
        "Réunion",
        "Saint Barthélemy",
        "Saint Helena, Ascension and Tristan da Cunha",
        "Saint Kitts and Nevis",
        "Saint Lucia",
        "Saint Martin (French part)",
        "Saint Pierre and Miquelon",
        "Saint Vincent and the Grenadines",
        "Samoa",
        "San Marino",
        "Sao Tome and Principe",
        "Saudi Arabia",
        "Senegal",
        "Serbia",
        "Seychelles",
        "Sierra Leone",
        "Singapore",
        "Sint Maarten (Dutch part)",
        "Slovakia",
        "Slovenia",
        "Solomon Islands",
        "Somalia",
        "South Africa",
        "South Georgia and the South Sandwich Islands",
        "South Sudan",
        "Spain",
        "Sri Lanka",
        "Sudan (the)",
        "Suriname",
        "Svalbard and Jan Mayen",
        "Sweden",
        "Switzerland",
        "Syrian Arab Republic",
        "Taiwan",
        "Tajikistan",
        "Tanzania, United Republic of",
        "Thailand",
        "Timor-Leste",
        "Togo",
        "Tokelau",
        "Tonga",
        "Trinidad and Tobago",
        "Tunisia",
        "Turkey",
        "Turkmenistan",
        "Turks and Caicos Islands (the)",
        "Tuvalu",
        "Uganda",
        "Ukraine",
        "United Arab Emirates (the)",
        "United Kingdom of Great Britain and Northern Ireland (the)",
        "United States Minor Outlying Islands (the)",
        "United States of America (the)",
        "Uruguay",
        "Uzbekistan",
        "Vanuatu",
        "Venezuela (Bolivarian Republic of)",
        "Viet Nam",
        "Virgin Islands (British)",
        "Virgin Islands (U.S.)",
        "Wallis and Futuna",
        "Western Sahara",
        "Yemen",
        "Zambia",
        "Zimbabwe",
        "Åland Islands",
      ],
      idFile: null,
      proofFile: null,
    };
  },
  methods: {
    async registerDetails() {
      try {
        const valid = this.$refs.form.validate();

        if (valid) {
          this.isLoading = true;
          const idRef = "uploads/documentation/" + this.idFile.name;
          const proofRef = "uploads/documentation/" + this.proofFile.name;
          const snapshotId = storage.ref(idRef).put(this.idFile);
          const snapshotProof = storage.ref(proofRef).put(this.proofFile);

          await usersCollection.doc(this.$store.state.userProfile.uid).set({
            firstname: this.firstname,
            lastname: this.lastname,
            country: this.country,
            idDoc: idRef,
            proofDoc: proofRef,
            uid: this.$store.state.userProfile.uid,
            walletAddress: this.walletAddress,
          });

          // fetch user profile
          router.push("/dashboard");

          this.isLoading = false;
        }
      } catch (e) {
        console.log(e);
        this.isLoading = false;
      }
    },
  },
  mounted() {
    console.log(this.$store.state.userProfile);
    // axios
    //   .get('')
    //   .then(response => (this.countries = response))
  },
};
</script>

<style></style>
